<template>
  <!-- 仓库档案（路桥定制）：仓库 / 堆料区 两个页签 -->
  <div class="warehouse-list">
      <el-tabs v-model="activeTab" class="warehouse-tabs" @tab-change="onTabChange">
        <!-- ==================== 仓库（保持原功能） ==================== -->

        <el-tab-pane label="仓库" name="warehouse">
          <list-page>
            <search-condition @search="resetSearch" :show-search="true">
              <template #default>
                <el-input v-model="searchInfo.searchKey" placeholder="名称/编码" @keydown.enter="resetSearch">
                  <template #prefix>关键字</template>
                </el-input>
                <el-select v-model="searchInfo.warehouseType" placeholder="请选择仓库类型" clearable>
                  <template #prefix>类型</template>
                  <el-option label="物资仓" :value="1"/>
                  <el-option label="临期仓" :value="2"/>
                </el-select>
                <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
                  <template #prefix>状态</template>
                  <el-option label="启用" :value="1"/>
                  <el-option label="停用" :value="0"/>
                </el-select>
              </template>
              <template #option>
                <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
                <page-button type="write" el-type="success" @click="openDialog()">新增仓库</page-button>
              </template>
            </search-condition>
            <list-table :show-shadow="false">
              <separator-page :show-border="true">
                <template #category>
                  <tree-dictionary v-if="queryDeparts" :filter="true" v-model:dictionary-list="departTree"
                                   dictionary-type="MERCHANT_CATEGORY" label-name="departName"
                                   @clickCategory="clickCategory" :query-function="queryDeparts"
                                   dialog-label="部门管理" :disabled="true"/>
                </template>
                <yq-table :data="dataList" height="100%" stripe border page-name="warehouseList">
                  <yq-table-column label="仓库编码" prop="warehouseCode" width="150rem"/>
                  <yq-table-column label="仓库名称" prop="warehouseName" min-width="180rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="仓库类型" prop="warehouseType" width="120rem" align="center">
                    <template v-slot="{row}">
                      <el-tag size="small" :type="row.warehouseType === 1 ? 'info' : 'warning'">{{row.warehouseType === 1 ? '物资仓' : '临期仓'}}</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="关联部门" prop="deptName" width="150rem"/>
                  <yq-table-column label="地址" prop="address" min-width="200rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="负责人" prop="managerName" width="120rem"/>
                  <yq-table-column label="状态" prop="status" width="120rem" align="center">
                    <template v-slot="{row}">
                      <el-tag size="small" :type="row.status === 1 ? 'success' : 'info'">{{row.status === 1 ? '启用' : '停用'}}</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
                    <template v-slot="{row}">
                      <table-button-group label="更多操作">
                        <table-button type="write" @click="openDialog(row)">编辑</table-button>
                        <table-button type="write" @click="updateStatus(row)">{{row.status === 1 ? '停用' : '启用'}}</table-button>
                        <table-button type="delete" el-type="danger" message="删除前将校验是否有关联业务数据" @click="toDelete(row)">删除</table-button>
                      </table-button-group>
                    </template>
                  </yq-table-column>
                </yq-table>
              </separator-page>
            </list-table>
            <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                       :total-count="searchInfo.totalCount" @onLoad="queryList"/>
          </list-page>

        </el-tab-pane>

        <!-- ==================== 堆料区（路桥定制） ==================== -->
        <el-tab-pane label="堆料区" name="area">
          <list-page>
            <search-condition @search="resetAreaSearch" :show-search="true">
              <template #default>
                <el-input v-model="areaSearchInfo.searchKey" placeholder="堆料区名称" @keydown.enter="resetAreaSearch">
                  <template #prefix>关键字</template>
                </el-input>
                <el-select v-model="areaSearchInfo.warehouseId" placeholder="请选择仓库" clearable filterable>
                  <template #prefix>仓库</template>
                  <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
                </el-select>
              </template>
              <template #option>
                <page-button type="read" el-type="primary" @click="resetAreaSearch">查询</page-button>
                <page-button type="write" el-type="success" @click="openAreaDialog()">新增堆料区</page-button>
                <page-button type="write" el-type="warning" @click="generateSelectedAreaQr">生成二维码</page-button>
                <print-button template-key="LUQIAO_WAREHOUSE_AREA" print-type="continuous"
                              :find-print-data="getAreaPrintData">打印二维码</print-button>
              </template>
            </search-condition>
            <list-table>
              <yq-table :data="areaList" height="100%" stripe border page-name="warehouseAreaList"
                        @selectionChange="areaSelectionChange">
                <yq-table-column type="selection" prop="selection" width="60rem" align="center" fixed="left"/>
                <yq-table-column label="堆料区" prop="areaName" min-width="180rem" :show-overflow-tooltip="true"/>
                <yq-table-column label="仓库" prop="warehouseName" min-width="180rem" :show-overflow-tooltip="true"/>
                <yq-table-column label="二维码" prop="wxQrCode" width="150rem" align="center">
                  <template v-slot="{row}">
                    <image-show v-if="row.wxQrCode" v-model="row.wxQrCode" width="0.8rem" height="0.8rem"/>
                    <el-button v-else link type="primary" @click="generateAreaQr(row)">生成二维码</el-button>
                  </template>
                </yq-table-column>
                <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem">
                  <template v-slot="{row}">
                    <table-button-group label="更多操作">
                      <table-button type="write" @click="openAreaDialog(row)">编辑</table-button>
                      <table-button type="delete" el-type="danger" message="是否确认删除该堆料区" @click="toDeleteArea(row)">删除</table-button>
                    </table-button-group>
                  </template>
                </yq-table-column>
              </yq-table>
            </list-table>
            <form-page v-model:page-number="areaSearchInfo.pageNumber" v-model:page-size="areaSearchInfo.pageSize"
                       :total-count="areaSearchInfo.totalCount" @onLoad="queryAreaList"/>
          </list-page>
        </el-tab-pane>
      </el-tabs>
    <!-- 仓库新增/编辑 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑仓库' : '新增仓库'" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="2" label-width="2.4rem" icon-width="0">
        <form-item label="仓库名称" :required="true" name="warehouseName" error-message="请输入仓库名称">
          <el-input v-model="dialogData.warehouseName" placeholder="请输入仓库名称"/>
        </form-item>
        <form-item label="仓库编码">
          <el-input v-model="dialogData.warehouseCode" placeholder="留空自动生成" :disabled="!!dialogData.id"/>
        </form-item>
        <form-item label="仓库类型" :required="true" name="warehouseType" error-message="请选择仓库类型">
          <el-select v-model="dialogData.warehouseType">
            <el-option label="物资仓" :value="1"/>
            <el-option label="临期仓" :value="2"/>
          </el-select>
        </form-item>
        <form-item label="关联部门">
          <depart-select v-model="dialogData.departCode" :data="departTree" placeholder="请选择部门"/>
        </form-item>
        <form-item label="负责人">
          <employee-select v-model="dialogData.manager" placeholder="请选择负责人"/>
        </form-item>
        <form-item label="状态">
          <el-select v-model="dialogData.status">
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </form-item>
        <form-item label="地址" :show-block="true">
          <el-input v-model="dialogData.address" placeholder="请输入仓库详细地址"/>
        </form-item>
        <form-item label="备注" :show-block="true">
          <el-input type="textarea" v-model="dialogData.remark" placeholder="备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </template>
    </el-dialog>

    <!-- 堆料区新增/编辑 -->
    <el-dialog v-model="showAreaDialog" :title="areaData.id ? '编辑堆料区' : '新增堆料区'" dialog-width="1"
               :close-on-click-modal="false">
      <form-items :data="areaData" :columns="1" label-width="2.4rem" icon-width="0">
        <form-item label="仓库" :required="true" name="warehouseId" error-message="请选择仓库">
          <el-select v-model="areaData.warehouseId" placeholder="请选择仓库" filterable style="width:100%">
            <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
          </el-select>
        </form-item>
        <form-item label="堆料区名称" :required="true" name="areaName" error-message="请输入堆料区名称">
          <el-input v-model="areaData.areaName" placeholder="请输入堆料区名称"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showAreaDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveArea">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import PrintButton from "@/views/h5/common/print/template/print-button.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import warehouseApi from "@/api/normal/stock/warehouseApi";
import warehouseAreaApi from "@/api/dz-luqiao/warehouseAreaApi";
import ImageShow from "@/components/h5/image/ImageShow.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LuqiaoWarehouseList",
  components: {
    ImageShow,
    TreeDictionary, FormItems, FormItem, DepartSelect, SeparatorPage,
    YqTableColumn, TableButtonGroup, TableButton, PageButton,
    SearchCondition, FormPage, ListTable, ListPage, EmployeeSelect, PrintButton
  },
  data() {
    return {
      activeTab: "warehouse",
      // 仓库
      searchInfo: {pageNumber: 1},
      dataList: [],
      departTree: [],
      showDialog: false,
      dialogData: {},
      queryDeparts: null,
      // 堆料区
      areaSearchInfo: {pageNumber: 1, pageSize: 10},
      areaList: [],
      areaSelected: [],
      showAreaDialog: false,
      areaData: {},
      warehouseOptions: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.init();
    this.resetSearch();
    this.queryDeparts = this.queryDepartList;
    this.loadWarehouseOptions();
  },
  methods: {
    onTabChange(name) {
      if (name === "area") {
        this.resetAreaSearch();
      }
    },
    // ==================== 仓库（原功能） ====================
    queryDepartList() {
      return new Promise(resolve => {
        warehouseApi.queryDepartList().then(res => resolve(res));
      })
    },
    init() {
    },
    async queryList() {
      const {records, totalCount} = await warehouseApi.queryList(this.searchInfo);
      records.forEach(r => {
        r.deptName = this.getDeptName(r.departCode);
      });
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    getDeptName(departCode) {
      if (!departCode) return "";
      let d = this.findDepart(this.departTree, departCode);
      return d ? (d.departName || d.name) : "";
    },
    findDepart(list, departCode) {
      if (!list) return null;
      for (let i = 0; i < list.length; i++) {
        if (list[i].departCode === departCode) return list[i];
        let child = this.findDepart(list[i].children, departCode);
        if (child) return child;
      }
      return null;
    },
    openDialog(row) {
      if (row) {
        this.dialogData = JSON.parse(JSON.stringify(row));
      } else {
        this.dialogData = {warehouseName: "", warehouseCode: "", warehouseType: 1, departCode: "", manager: "", address: "", status: 1, remark: ""};
      }
      this.showDialog = true;
    },
    async saveData() {
      if (!this.dialogData.warehouseName) {
        this.$message.error("请输入仓库名称");
        return;
      }
      await warehouseApi.save(this.dialogData);
      this.showDialog = false;
      this.resetSearch();
      // 仓库有变化，刷新堆料区下拉
      this.loadWarehouseOptions();
    },
    async updateStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      await warehouseApi.updateStatus(row.id, status);
      this.$message.success(status === 1 ? "已启用" : "已停用");
      this.resetSearch();
    },
    async toDelete(row) {
      await warehouseApi.delete(row.id);
      this.resetSearch();
    },
    clickCategory(data) {
      this.searchInfo.departCode = data.departCode;
      this.queryList();
    },

    /**
     * 堆料区的仓库下拉：取仓库档案的全部仓库
     *
     * ★ 不能用通用接口 /basedata/common/data/warehouse/queryAll —— 那个接口按当前职员主部门
     *   （或职员仓库授权）过滤，只会返回一部分仓库；堆料区这里是基础档案配置，要和「仓库」页签一致。
     */
    loadWarehouseOptions() {
      warehouseApi.queryList({pageNumber: 1, pageSize: 1000}).then(res => {
        this.warehouseOptions = (res && res.records) || [];
      }).catch(() => {
        this.warehouseOptions = [];
      });
    },

    // ==================== 堆料区 ====================
    async queryAreaList() {
      const {records, totalCount} = await warehouseAreaApi.queryList(this.areaSearchInfo);
      this.areaList = records || [];
      this.areaSearchInfo.totalCount = totalCount || 0;
    },
    resetAreaSearch() {
      this.areaSearchInfo.pageNumber = 1;
      this.queryAreaList();
    },
    areaSelectionChange(list) {
      this.areaSelected = list || [];
    },
    openAreaDialog(row) {
      if (row) {
        this.areaData = JSON.parse(JSON.stringify(row));
      } else {
        this.areaData = {warehouseId: this.areaSearchInfo.warehouseId || "", areaName: ""};
      }
      this.showAreaDialog = true;
    },
    async saveArea() {
      if (!this.areaData.warehouseId) {
        this.$message.error("请选择仓库");
        return;
      }
      if (!this.areaData.areaName) {
        this.$message.error("请输入堆料区名称");
        return;
      }
      await warehouseAreaApi.save(this.areaData);
      this.showAreaDialog = false;
      this.resetAreaSearch();
    },
    async toDeleteArea(row) {
      await warehouseAreaApi.delete(row.id);
      this.resetAreaSearch();
    },
    /** 单行生成二维码 */
    async generateAreaQr(row) {
      await warehouseAreaApi.updateQrCode([row.id]);
      this.resetAreaSearch();
    },
    /** 勾选的多行批量生成二维码 */
    async generateSelectedAreaQr() {
      if (!this.areaSelected.length) {
        this.$message.error("请先勾选堆料区");
        return;
      }
      await warehouseAreaApi.updateQrCode(this.areaSelected.map(row => row.id));
      this.resetAreaSearch();
    },
    /**
     * 打印数据（连续打印）：勾选的堆料区二维码
     * 打印模板里用「二维码(自定义)」绑定 qrcodeImage
     */
    getAreaPrintData() {
      if (!this.areaSelected.length) {
        return null;
      }
      const rows = this.areaSelected.filter(row => row.wxQrCode);
      if (rows.length === 0) {
        this.$message.error("勾选的堆料区还没有二维码，请先生成二维码");
        return null;
      }
      return rows.map(row => ({
        areaName: row.areaName,
        warehouseName: row.warehouseName,
        qrcodeImage: row.wxQrCode,
      }));
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tabs";
.warehouse-list {
  height: 100%;

  .warehouse-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;

    :deep(.el-tabs__header) {
      margin: 0;
      background: #fff;
      padding: 0 12px;
      border-radius: 8px 8px 0 0;
    }

    :deep(.el-tabs__content) {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    :deep(.el-tab-pane) {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }
  }

  .qr-image {
    width: 60px;
    height: 60px;
  }
}
</style>
